import { ViewEncapsulation, Component, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { Calendar, View } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import { DateRangeInput } from '@fullcalendar/core/datelib/date-range';
import interactionPlugin from '@fullcalendar/interaction';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalService } from 'src/app/shared/global.service';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { UrlService } from 'src/app/shared/services/url.service';
import { UtilService } from 'src/app/shared/services/util.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { AlertService } from 'src/app/shared/services/alert.service';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { ParametrosModel } from 'src/app/models/parametros.model';

@Component({
    selector: 'app-agenda',
    templateUrl: './agenda.component.html',
    styleUrls: ['./agenda.component.scss'],
    encapsulation: ViewEncapsulation.None
})

/**
 * @author jnmartinez
 */
export class AgendaComponent implements OnInit {

    @ViewChild('calendar') $calendar: FullCalendarComponent;

    festivos = [];
    presentarCalendario = false;
    cargado = [false, false];
    calendarPlugins = [dayGridPlugin, interactionPlugin];
    colorFechaActual = '#e66a6a';
    colorFechaSeleccionada = '#0000ff';
    colorFechaDisponible = '#ffff72';
    rangoAgenda = 30;
    nombreParametros: string[] = [DominiosService.AGENDA_FECHA_ACTUAL
        , DominiosService.AGENDA_FECHA_SELECCIONADA, DominiosService.AGENDA_FECHA_DISPONIBLE
        , DominiosService.MAXIMO_DIAS_AGENDA];


    fechaAgenda: any;
    fechaSeleccionada: Date;
    turnos: { fechaInicio: string, fechaFin: string }[] = [];

    language = 'es';
    header = { right: 'prev,next' };

    agenda: any;

    fechaInicio: Date;
    fechaFin: Date;

    constructor(
        private activeModal: NgbActiveModal,
        private spinner: NgxSpinnerService,
        private global: GlobalService,
        private urlService: UrlService,
        private utils: UtilService,
        private alertService: AlertService) {

    }

    ngOnInit() {
        this.consultarRangoFechas();
        this.consultarParametros();
        this.consultarFestivos();
        this.obtenerVisualizacion();
    }

    /**
     * Consulta el rango de fechas a través de los parámetros de base de datos
     */
    private consultarRangoFechas() {
        this.obtenerFechaValorParametro(ConstantesService.NOMBRE_PARAMETRO_FECHA_INICIAL).then(parametro => {
            let parametroFechaInicio: ParametrosModel = parametro;
            let fecha = parametroFechaInicio.valor;
            this.fechaInicio = moment(fecha.toString(), 'D/M/YYYY').toDate();
        }).catch(err => {
            console.log(err);
        });

        this.obtenerFechaValorParametro(ConstantesService.NOMBRE_PARAMETRO_FECHA_FINAL).then(parametro => {
            let parametroFechaFin: ParametrosModel = parametro;
            let fecha = parametroFechaFin.valor;
            this.fechaFin = moment(fecha.toString(), 'D/M/YYYY').toDate();
        }).catch(err => {
            console.log(err);
        });
    }

    /**
  * Este método se encarga de consultar el parámetro y generar un dto
  * @param nombreParametro 
  * @returns retorna un parametro DTO con toda la información.
  */
    public obtenerFechaValorParametro(nombreParametro: String): Promise<ParametrosModel> {
        return new Promise((resolve, reject) => {
            const serviceProvider = 'parametroPorNombre';
            const queryParams: Array<[string, string]> = new Array<[string, string]>();
            queryParams.push(['nombreParametro', (nombreParametro.toString())]);
            const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_TRANS);
            this.global.getPublico(url).subscribe(
                data => {
                    let parametrosModel: ParametrosModel = data;
                    resolve(parametrosModel);
                }, err => {
                    console.log(err);
                    reject(err);
                }
            );
        });
    }


    /**
     * Método que valida si ya se cargaron los datos necesarios para presentar el calendario
     */
    obtenerVisualizacion() {
        const isFinalizado = this.cargado.filter(x => x);
        if (isFinalizado.length === 2) {
            this.presentarCalendario = true;
        } else {
            setTimeout(() => {
                this.obtenerVisualizacion();
            }, 200);
        }

    }

    //#region metodos calendario

    obtenerFechasValidas = (currentDate: Date): DateRangeInput => {

        let initialDate: Date = this.fechaInicio;
        //initialDate = moment('2021-06-10', 'YYYY-MM-DD').toDate();
        let finishDate: Date = this.fechaFin;
        //finishDate = moment('2021-07-31', 'YYYY-MM-DD').toDate();

        //Este es el código original antes del cambio temporal

        /**
         *
         
        return {
            start: currentDate,
            end: moment(currentDate).clone().add(this.rangoAgenda, 'days').toDate()
        };

         */

        return {
            start: initialDate,
            end: finishDate
        };

    }

    eventoFecha(arg: {
        date: Date;
        dateStr: string;
        allDay: boolean;
        resource?: any;
        dayEl: HTMLElement;
        jsEvent: MouseEvent;
        view: View;
    }) {
        const fecha = moment(arg.date).format(ConstantesService.FORMATO_FECHA_ISO);

        let initialDate: Date = this.fechaInicio;
        //initialDate = moment('2021-06-10', 'YYYY-MM-DD').toDate();
        let finishDate: Date = this.fechaFin;
        //finishDate = moment('2021-07-31', 'YYYY-MM-DD').toDate();

        if (arg.date <= finishDate && arg.date >= initialDate) {
            if (!this.festivos || this.festivos.filter((x: string) => moment(x).format(ConstantesService.FORMATO_FECHA_ISO) === fecha
            ).length === 0) {
                const fechaActual = new Date(Date.parse(moment(new Date()).format(ConstantesService.FORMATO_FECHA_ISO)));
                //const fechaFinal = moment(fechaActual).clone().add(this.rangoAgenda, 'days').toDate();
                const fechaFinal = this.fechaFin;
                if (arg.date <= fechaFinal && arg.date >= fechaActual) {
                    this.fechaSeleccionada = arg.date;
                    this.$calendar.getApi().removeAllEvents();
                    this.$calendar.getApi().addEvent({
                        start: arg.date,
                        allDay: true,
                        backgroundColor: this.colorFechaSeleccionada
                    });
                    this.turnos = [];
                    this.fechaAgenda = undefined;
                    this.consultarTurnosAgenda();
                }
            }
        } else {
            this.alertService.generateAlertInfo('No se encontraron turnos disponibles para la fecha seleccionada', '');
        }
    }

    construirDia(arg: {
        view: View;
        date: Date;
        allDay?: boolean;
        el: HTMLElement;
    }) {
        const fecha = moment(arg.date).format(ConstantesService.FORMATO_FECHA_ISO);
        if (fecha === moment(new Date()).format(ConstantesService.FORMATO_FECHA_ISO)) {
            arg.el.style.background = this.colorFechaActual;
        } else if (!this.festivos || this.festivos.filter(x => moment(x).format(ConstantesService.FORMATO_FECHA_ISO) === fecha
        ).length === 0) {
            const fechaActual = new Date(Date.parse(moment(new Date()).format(ConstantesService.FORMATO_FECHA_ISO)));
            // const fechaFinal = moment(fechaActual).clone().add(this.rangoAgenda, 'days').toDate();
            const fechaFinal = this.fechaFin;
            if (arg.date <= fechaFinal && arg.date >= fechaActual) {
                arg.el.style.background = this.colorFechaDisponible;
            }
        }
    }

    /**
     * 
     * @param arg Método temporal para excluir un rango de fechas de acuerdo a un evento 
     * extraordinario.
     */

    construirDiaTemp(arg: {
        view: View;
        date: Date;
        allDay?: boolean;
        el: HTMLElement;
    }) {
        const fecha = moment(arg.date).format(ConstantesService.FORMATO_FECHA_ISO);
        if (fecha === moment(new Date()).format(ConstantesService.FORMATO_FECHA_ISO)) {
            arg.el.style.background = this.colorFechaActual;
        } else if (!this.festivos || this.festivos.filter(x => moment(x).format(ConstantesService.FORMATO_FECHA_ISO) === fecha
        ).length === 0) {

            let initialDate: Date = this.fechaInicio;
            //initialDate = moment('2021-06-10', 'YYYY-MM-DD').toDate();
            let fechaFinal: Date = this.fechaFin;
            //fechaFinal = moment('2021-07-31', 'YYYY-MM-DD').toDate();

            if (arg.date <= fechaFinal && arg.date >= initialDate) {
                arg.el.style.background = this.colorFechaDisponible;
            }
        }
    }

    //#endregion

    /**
     * Método que envía la fecha seleccionada al componente desde el que se realizó la invocación
     */
    close() {
        // emite la fecha seleccionada
        // tslint:disable-next-line: triple-equals
        const turno = this.turnos.find(t => t.fechaInicio == this.fechaAgenda);
        if (turno) {
            this.activeModal.close(turno);
        }
    }

    cancelar() {
        this.activeModal.close({});
    }

    /**
     * Método que obtiene los parametros necesarios para la obtención de la agenda
     */
    private consultarParametros() {
        const serviceProvider = 'consultarParametros';
        const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_TRANS);
        this.global.postPublico(url, this.nombreParametros).subscribe(
            data => {
                data.forEach(parametro => {
                    switch (parametro.nombre) {
                        case DominiosService.AGENDA_FECHA_ACTUAL:
                            this.colorFechaActual = '#' + parametro.valor;
                            break;
                        case DominiosService.AGENDA_FECHA_SELECCIONADA:
                            this.colorFechaSeleccionada = '#' + parametro.valor;
                            break;
                        case DominiosService.AGENDA_FECHA_DISPONIBLE:
                            this.colorFechaDisponible = '#' + parametro.valor;
                            break;
                        default:
                            this.rangoAgenda = Number(parametro.valor);
                    }
                });
                this.cargado[0] = true;
            }, err => {
                this.cargado[0] = true;
                this.cathException('Se presentó un problema al obtener los parametros requeridos para la agenda');
            });
    }

    /**
     * Método que obtiene el listado de festivos
     */
    private consultarFestivos() {
        const serviceProvider = 'consultarFestivos';
        const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_TRANS);
        this.global.getPublico(url).subscribe(
            data => {
                this.festivos = data;
                this.cargado[1] = true;
            }, err => {
                this.cargado[1] = true;
            });
    }



    /**
     * Método que obtiene los datos del ciudadano si existen
     * @author jnmartinez
     */
    private consultarTurnosAgenda() {
        const serviceProvider = 'obtenerAgendas';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['fechaAgenda', this.fechaSeleccionada.getTime().toString()]);
        const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
        this.spinner.show();
        this.global.postPublico(url, this.agenda).subscribe(
            data => {
                this.turnos = data;

                this.turnos = this.turnos.filter(this.turnosMedioDia);
                console.log(this.turnos);


                if (this.turnos.length === 0) {
                    this.alertService.generateAlertInfo('No se encontraron turnos disponibles para la fecha seleccionada', '');
                }
                this.spinner.hide();
            }, err => {
                if (err.error && err.error.message) {
                    this.cathException(err.error.message);
                }
                this.cathException('Se presentó un problema al obtener los turnos disponibles');
            });
    }

    turnosMedioDia(element, index, array) {
        console.log(element.fechaInicio);
        let momentDate = moment(element.fechaInicio).toDate();
        console.log(moment(element.fechaInicio).utc().hour());
        console.log(moment(element.fechaInicio).hour());
        return (moment(element.fechaInicio).hour() < 12 || moment(element.fechaInicio).hour() > 13);
    }

    /**
     * Método de control de Excepciones
     * @param  error mensaje saliente respecto al error ocurrido
     * @return void
     */
    private cathException(error) {
        this.spinner.hide();
        this.alertService.generateAlertError(error, 'Error');
    }
}

